import * as React from 'react';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import { InfoBarCalloutAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export interface InfoBarMessageWithCalloutActionProps extends InfoBarCalloutAction {
    className?: string;
}

export function InfoBarMessageWithCustomAction(props: InfoBarMessageWithCalloutActionProps) {
    const linkRef = React.useRef<HTMLElement>();
    const [isCalloutVisible, setIsCalloutVisible] = React.useState<boolean>(false);
    const onLinkClicked = (evt: React.MouseEvent<Element>): void => {
        evt.stopPropagation();
        setIsCalloutVisible(!isCalloutVisible);
    };
    const onCalloutDismiss = (): void => {
        setIsCalloutVisible(false);
    };
    const onLinkRef = (ref: HTMLAnchorElement) => {
        linkRef.current = ref;
    };
    return (
        <>
            <a
                href={'javascript:void(0);'}
                className={props.className}
                onClick={onLinkClicked}
                ref={onLinkRef}>
                {props.text}
            </a>
            <Callout
                target={linkRef.current}
                directionalHint={DirectionalHint.rightTopEdge}
                calloutMaxWidth={props.maxWidth}
                onDismiss={onCalloutDismiss}
                hidden={!isCalloutVisible}>
                {props.calloutContent}
            </Callout>
        </>
    );
}

export default InfoBarMessageWithCustomAction;
